<template>
  <!--div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-4">
          <div class="card-group mb-4">
            <div class="card p-4">
              <div class="card-body">
                <h1>{{$t('LOGIN')}}</h1>
                <p class="text-muted">{{$t('LOGINTOYOURACCOUNT')}}</p>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><icon icon="user"></icon></span>
                  <input type="text" v-model="username" v-on:keyup.13="login" class="form-control" v-bind:placeholder="$t('USERNAME')">
                </div>
                <div class="input-group mb-4">
                  <span class="input-group-addon"><icon icon="lock"></icon></span>
                  <input type="password" v-model="password" v-on:keyup.13="login" class="form-control" v-bind:placeholder="$t('PASSWORD')">
                </div>
                <div class="row">
                  <div class="col-12">
                    <p class="bg-danger" v-if="loginResponse.error && loginResponse.notice">{{loginResponse.notice}}</p>
                  </div>
                  <div class="col-12">
                    <button type="button" v-on:click.prevent="login" class="btn btn-primary px-4 float-right">{{$t('LOGIN')}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div-->

  <div class="app login">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="login-left">
            <img src="../../../assets/img/logo.svg" class="login-logo">
            <div class="login-fields">
              <h1>{{$t('LOGINTOYOURACCOUNT')}}</h1>
              <!--p class="text-muted">{{$t('LOGINTOYOURACCOUNT')}}</p-->

              <b-form-fieldset v-bind:label="$t('USERNAME')" class="full-input-group mb-3" :class="{'two-factor-hidden': twoFactorAuth}">
                  <b-form-input type="text" v-model="username" v-on:keyup.13="login"></b-form-input>
              </b-form-fieldset>

              <b-form-fieldset v-bind:label="$t('PASSWORD')" class="full-input-group mb-3" :class="{'two-factor-hidden': twoFactorAuth}">
                  <b-form-input type="password" v-model="password" v-on:keyup.13="login"></b-form-input>
              </b-form-fieldset>

              <div class="row">
                <div class="col-12">
                  <p class="bg-danger" v-if="loginResponse.error && loginResponse.notice">{{loginResponse.notice}}</p>
                </div>
                <div class="col-12">
                  <button type="button" v-on:click.prevent="login" class="btn-bis btn-primary w-100">{{$t('LOGIN')}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 hidden-on-small">
          <div class="login-tehnician"><img src="../../../assets/img/login-technician.png"></div>
          <div class="login-bg-img">&nbsp;</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Login',
  data: function()
  {
    return {username: '', password: ''}
  },
  methods:
  {
    ...mapActions({
      actLogin: 'login'
    }),
    login: function(bvEvt)
    {
      bvEvt.preventDefault();
      this.actLogin({username: this.username, password: this.password});
    }
  },
  computed:
  {
    ...mapGetters([
      'loginResponse'
    ])
  }
}
</script>
